import React from "react";
import { Route } from "react-router-dom";
import NavBar from "./NavBar";

const NavRoute = ({
  exact,
  path,
  stepName,
  stepText,
  buttonText,
  buttonPath,
  component: Component
}) => (
  <Route
    exact={exact}
    path={path}
    render={props => {
      return (
        <div>
          <NavBar
            stepName={stepName}
            stepText={stepText}
            buttonText={buttonText}
            buttonPath={buttonPath}
          />
          <Component {...props} />
        </div>
      );
    }}
  />
);

export default NavRoute;
